import React from 'react';
import PortfolioManagement from '../components/PortfolioManagement';

const PortfolioManagementPage: React.FC = () => <PortfolioManagement />;

export default PortfolioManagementPage;
